import Vue from 'vue'
import App from './app.vue'
import router from './router'

import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill()

Vue.config.productionTip = false

let vhMax = 0
let vhMin = 999999

// ========================================== //

function domContentLoaded() {
  // console.log('domContentLoaded !!!')
  // console.log(window)
  document.body.classList.add('uv-finished-loading')
}

function documentLoaded() {
  // console.log('documentLoaded')
  // document.body.classList.add('uv-finished-loading')
}

function windowWasResized() {
  // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
  const vh = window.innerHeight * 0.01
  vhMax = Math.max(vh, vhMax)
  vhMin = Math.min(vh, vhMin)

  document.documentElement.style.setProperty('--vh', `${vh}px`)
  document.documentElement.style.setProperty('--vh-max', `${vhMax}px`)
  document.documentElement.style.setProperty('--vh-min', `${vhMin}px`)
  // document.documentElement.style.setProperty('--vh-rounded', `${Math.round(vh)}px`)
}

// function windowFocusOccurred() {

// }

// function windowBlurOccurred() {
  
// }

// ========================================== //

// eslint-disable-next-line
function vueCreated(vue: Vue) {
  windowWasResized()
  window.addEventListener('resize', windowWasResized)
  // window.addEventListener('focus', windowFocusOccurred)
  // window.addEventListener('blur', windowBlurOccurred)

  document.addEventListener('DOMContentLoaded', domContentLoaded)
  window.onload = documentLoaded
}

// ========================================== //

new Vue({
  router,
  render: h => h(App),
  created: function () { vueCreated(this) }
}).$mount('#app')

